import { render } from "./AlgorithmResultMangerView.vue?vue&type=template&id=62f2cc0a&scoped=true"
import script from "./AlgorithmResultMangerView.vue?vue&type=script&lang=js"
export * from "./AlgorithmResultMangerView.vue?vue&type=script&lang=js"

import "./AlgorithmResultMangerView.vue?vue&type=style&index=0&id=62f2cc0a&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f2cc0a"]])

export default __exports__